var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXx1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 190.5,
    height: 318.9,
    viewBox: "0 0 190.5 318.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 27.056,
    height: 50.731,
    fill: "none",
    stroke: "#117446",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 132.5,
    height: 79.443,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#117446",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 59.012,
    height: 40.221,
    fill: "none",
    stroke: "#117446",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(-1329 -449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(1492.444 487.415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M.009.5,10.772.682A15.969,15.969,0,0,1,26.5,16.593l.056,34.14",
    transform: "translate(0 -0.002)",
    fill: "none",
    stroke: "#117446",
    strokeMiterlimit: 4.001,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(1387 449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M132,0V22.928a16,16,0,0,1-16,16H16.5a16,16,0,0,0-16,16V79.443",
    fill: "none",
    stroke: "#117446",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(1329 488.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M0,.5H42.62a15.947,15.947,0,0,1,15.9,16V40.221",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#117446",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M1387,528.443V692.9",
    transform: "translate(0.5)",
    fill: "none",
    stroke: "#117446",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "translate(1345.469 688.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M7.059,52.091,36.294,64.659a14,14,0,0,0,11.475,0L77,52.091a4,4,0,0,0,0-7.377l-4.645-2.049a7.99,7.99,0,0,0-6.148,0L50.365,49.5a18.609,18.609,0,0,1-6.148,1.639,19.5,19.5,0,0,1-10.109-1.5L17.851,42.665a7.99,7.99,0,0,0-6.148,0L7.059,44.714C3.78,45.943,3.78,50.588,7.059,52.091Z",
    transform: "translate(0 13.711)",
    fill: "#117446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M7.059,25.775,36.294,38.343a14,14,0,0,0,11.475,0L77,25.775A4,4,0,0,0,77,18.4L47.769,5.83a14,14,0,0,0-11.475,0L7.059,18.261A4.1,4.1,0,0,0,7.059,25.775Z",
    transform: "translate(0 0)",
    fill: "#117446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M7.059,37.391,36.294,49.959a14,14,0,0,0,11.475,0L77,37.391a4,4,0,0,0,0-7.377l-4.645-2.049a7.99,7.99,0,0,0-6.148,0L50.365,34.8a18.609,18.609,0,0,1-6.148,1.639,19.5,19.5,0,0,1-10.109-1.5L17.851,27.965a7.99,7.99,0,0,0-6.148,0L7.059,30.014A4,4,0,0,0,7.059,37.391Z",
    transform: "translate(0 8.329)",
    fill: "#117446"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXx1);
export default __webpack_public_path__ + "static/media/xx1.386cda8b409f92c98bb762368da93033.svg";
export { ForwardRef as ReactComponent };